// extracted by mini-css-extract-plugin
export default {"root":"MobileMenu_root__khwS1","list":"MobileMenu_list__rNS+d","listItem":"MobileMenu_listItem__Bmsmk","listItemActive":"MobileMenu_listItemActive__vMToT"};